import {
  IDropdownOption,
  IconButton,
  Stack,
  Text,
  TooltipHost,
} from '@fluentui/react';
import { DropdownFilter, FilterArrayType } from 'common/components/Filters';
import { getUpdatedFilterArray } from 'common/components/Filters/utils';
import React, { useState } from 'react';
import { useStyles } from './index.styles';

interface ActionBarProps {
  onFilterChange: (filterArray: FilterArrayType[]) => void;
  notifyTypesOptions: IDropdownOption[];
}
export const ActionBar: React.FC<ActionBarProps> = ({
  onFilterChange,
  notifyTypesOptions,
}) => {
  const styles = useStyles();
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [filterTypes, setFilterTypes] = useState<FilterArrayType[]>([]);
  const onOptionChange = (filterdata: FilterArrayType) => {
    const availableFilters = [...filterTypes];
    const newFilters = getUpdatedFilterArray(filterdata, availableFilters);
    setFilterTypes(newFilters);
    onFilterChange?.(newFilters);
  };

  const onFilterClear = () => {
    if (filterTypes.length) onFilterChange([]);
    setFilterTypes([]);
  };

  return (
    <Stack horizontal verticalAlign="center">
      <Stack style={{ paddingRight: 30 }}>
        {showFilters && (
          <>
            <DropdownFilter
              filterKey={'notifyTypeId'}
              options={notifyTypesOptions}
              placeholder={'Notify Cycle Types'}
              onOptionChange={onOptionChange}
              NoBgColor
            />
          </>
        )}
      </Stack>

      <TooltipHost content={showFilters ? 'Close filters' : 'Open Filters'}>
        <Stack
          horizontal
          verticalAlign="center"
          style={{ cursor: 'pointer' }}
          tokens={{ childrenGap: 8 }}
          onClick={() => {
            if (showFilters) onFilterClear?.();
            setShowFilters((prevState) => !prevState);
          }}
        >
          <IconButton
            key="filters"
            className={
              showFilters
                ? styles.iconButtonPrimaryStyles
                : styles.iconButtonStyles
            }
            iconProps={{ iconName: showFilters ? 'ClearFilter' : 'Filter' }}
          />
          <Text>Filters</Text>
        </Stack>
      </TooltipHost>
    </Stack>
  );
};
